import sectionCardVitalSurroundCss from '../css-snippets/section-card-vital-surround';

const html = `
<style>${sectionCardVitalSurroundCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true" data-color="#000000" data-text-color="#000000"
  style="background-color: #ffffff; color: #000000; --color-text: #000000; --color-background: #ffffff;">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-show-title="true" data-attribute="title-card" class="title-card">
          <h2 style="text-align: center;">Feel (and see) a whole-body difference</h2>
        </div>
        <div class="wrap-content">
          <div class="main-item">
            <img data-attribute="img-main-item"
              src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf219a22c721fd207643ec.webp" alt="">
          </div>
          <div data-attribute="list-item" class="wrap-items">
            <div data-attribute="item-surround" class="item-surround">
              <div class="wrap-img-item">
                <img data-attribute="img-item"
                  src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf1f6f6958b75c327cb6ea.webp" alt="">
              </div>
              <div data-attribute="text-item" class="text-item">Colagen Peptides</div>
            </div>

            <div data-attribute="item-surround" class="item-surround">
              <div class="wrap-img-item">
                <img data-attribute="img-item"
                  src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf1f77fc29b51a7f4f7320.webp" alt="">
              </div>
              <div data-attribute="text-item" class="text-item">NR</div>
            </div>

            <div data-attribute="item-surround" class="item-surround">
              <div class="wrap-img-item">
                <img data-attribute="img-item"
                  src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf1f96802e76745ec59c81.webp" alt="">
              </div>
              <div data-attribute="text-item" class="text-item">Vitamin C</div>
            </div>

            <div data-attribute="item-surround" class="item-surround">
              <div class="wrap-img-item">
                <img data-attribute="img-item"
                  src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf1fe453c82fbf17acc78b.webp" alt="">
              </div>
              <div data-attribute="text-item" class="text-item">Hyaluronic Acid</div>
            </div>

            <div data-attribute="item-surround" class="item-surround">
              <div class="wrap-img-item">
                <img data-attribute="img-item"
                  src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf1f8e8f65a3609884feca.webp" alt="">
              </div>
              <div data-attribute="text-item" class="text-item">Keratin</div>
            </div>

            <div data-attribute="item-surround" class="item-surround">
              <div class="wrap-img-item">
                <img data-attribute="img-item"
                  src="https://cdn.skyfastimg.com/images/2026/04/03/image-69cf1feda50b5b1db29282d6.webp" alt="">
              </div>
              <div data-attribute="text-item" class="text-item">L-glutathione</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
